// extracted by mini-css-extract-plugin
export default {"phone":"phone-module--phone--97ptg"};